const ChevronsFacingAway = () => (
  <>
    <path
      fill="currentColor"
      d="m12 18.83 2.767-2.766a.51.51 0 0 1 .35-.156.48.48 0 0 1 .37.156.5.5 0 0 1 .165.359q0 .195-.165.36l-2.921 2.92a.8.8 0 0 1-.268.184.8.8 0 0 1-.298.053.8.8 0 0 1-.298-.053.8.8 0 0 1-.268-.183l-2.92-2.921a.51.51 0 0 1-.156-.35.48.48 0 0 1 .156-.37q.165-.165.359-.165.195 0 .36.166zm0-13.638L9.233 7.96a.51.51 0 0 1-.35.156.48.48 0 0 1-.37-.156.5.5 0 0 1-.165-.36q0-.195.166-.36l2.92-2.92a.8.8 0 0 1 .268-.184.8.8 0 0 1 .298-.053.8.8 0 0 1 .298.053.8.8 0 0 1 .268.183l2.92 2.922q.147.146.156.35a.48.48 0 0 1-.155.369.5.5 0 0 1-.36.165.5.5 0 0 1-.36-.165z"
    />
  </>
)
export default ChevronsFacingAway
